import React, { useCallback, useMemo, useState } from "react";
import { useFormatting } from "locale";
import { useNavigate, useParams } from "react-router";
import { Icon } from "ui-library";
import { ICON_LONG_ARROW_RIGHT } from "ui-library/components/Icon";

const useProposalOverview = () => {
    // Implement the hook logic here
    const data = [
        {
            id: "1",
            product: "Product A",
            advisor: "Advisor A",
            createdDate: new Date().toISOString(),
        },
        {
            id: "2",
            product: "Product B",
            advisor: "Advisor B",
            createdDate: new Date().toISOString(),
        },
        {
            id: "3",
            product: "Product C",
            advisor: "Advisor C",
            createdDate: new Date().toISOString(),
        },
    ]; 
    
    // Replace this with actual data fetching logic
    const { getFormattedDate } = useFormatting();
    const navigate = useNavigate();
    const { dfsClientId } = useParams();
    const [page, setPage] = useState(1);

    const urlClientId = useMemo(() => dfsClientId, [dfsClientId]);

    const onNavigationClick = useCallback(
        ({ proposalId }) => {
            return;
            navigate(`/client/${urlClientId}/proposalDetails/${proposalId}`);
        },
        [navigate, urlClientId],
    );

    const list = data?.map((proposal: any) => {
        return {
            proposalId: proposal?.id,
            product: proposal?.product,
            advisor: proposal?.advisor,
            createdDate: getFormattedDate(proposal?.createdDate),
            proposalDetails: (
                <Icon
                    type={ICON_LONG_ARROW_RIGHT}
                    className="navigationButtonArrow"
                    onClick={() =>
                        onNavigationClick({ proposalId: proposal?.id })
                    }
                />
            ),
        };
    });

    return {
        list,
        totalPages: list?.length,
        page,
        setPage,
        isLoading: false,
        error: null,
    };
};

export default useProposalOverview;
